import { Link } from "react-router-dom";
import { EXAMS } from "../data/exams";
import { bankStats } from "../data/questions";
import { ExamBadge, ProgressBar, useDocumentTitle } from "../components/ui";
import { examMastery, readiness } from "../lib/stats";
import { useProgress } from "../lib/store";
import { pick, useT } from "../i18n";

export function ExamsPage() {
  const t = useT();
  useDocumentTitle(t("Đề thi", "Exams"));
  const p = useProgress();
  const lang = p.lang;
  return (
    <>
      <h1>{t("Bốn chứng chỉ Claude", "The four Claude certifications")}</h1>
      <p className="muted">
        {t(
          "Đi từ thấp tới cao. Mỗi kỳ thi thật: 120 phút, câu hỏi tình huống, thang 100–1000, đạt từ 720, hiệu lực 12 tháng. Hiện chỉ nhân viên tổ chức thuộc Claude Partner Network đăng ký được (qua Pearson VUE) — nhưng kiến thức thì ai cũng nên nắm.",
          "From foundational to advanced. Every real exam: 120 minutes, scenario-based items, scaled 100–1000, pass at 720, valid 12 months. Registration is currently limited to Claude Partner Network employees (via Pearson VUE) — but the knowledge is worth having for everyone.",
        )}{" "}
        <Link to="/guide">{t("Xem cẩm nang thi", "See the exam guide")}</Link>
      </p>
      <div className="callout">
        {lang === "vi" ? (
          <>
            <strong>Đề bằng tiếng Anh như kỳ thi thật.</strong> Đề bài và đáp án luôn hiển thị bằng tiếng Anh; phần giải thích theo ngôn ngữ bạn chọn.
            Sau khi trả lời, bạn có thể mở <em>“Xem đề bằng tiếng Việt”</em> để đối chiếu thuật ngữ.
          </>
        ) : (
          <><strong>Questions are in English, like the real exam.</strong> Mock exams follow the official item counts and domain weights.</>
        )}
      </div>
      <div className="stack mt">
        {EXAMS.map((e) => {
          const m = examMastery(e.id, p);
          const r = readiness(e.id, p);
          return (
            <Link key={e.id} to={`/exams/${e.id}`} className="card link">
              <div className="row" style={{ alignItems: "flex-start" }}>
                <ExamBadge examId={e.id} size={44} />
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div className="row between">
                    <h2 className="mb-0">{e.code} · {e.name}</h2>
                    <span className="chip">${e.priceUsd}</span>
                  </div>
                  <p className="muted small">{pick(e.audience, lang)}</p>
                  <p className="small mb-0">
                    {t(`${e.items} câu · ${e.durationMin} phút · đạt 720/1000`, `${e.items} items · ${e.durationMin} min · pass 720/1000`)}
                    {e.structure && <> · {pick(e.structure, lang)}</>}
                  </p>
                  <div className="row mt small muted">
                    <span>{bankStats().byExam[e.id] ?? 0} {t("câu luyện", "practice questions")}</span>·
                    <span>{e.domains.length} domain</span>
                    {e.scenarios && <>·<span>{e.scenarios.length} {t("kịch bản", "scenarios")}</span></>}·
                    <span>{r === null ? t("Chưa có điểm dự đoán", "No predicted score yet") : `${t("Điểm dự đoán", "Predicted score")} ${r}/1000`}</span>
                  </div>
                  <div className="mt"><ProgressBar value={(m.seen / m.total) * 100} label={`${t("Tiến độ", "Progress")} ${e.code}`} /></div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
}
